import { d as e } from "../../../chunk-GSYRQO2U-911f8fc9.js";
import { createMultiStyleConfigHelpers as t } from "@chakra-ui/react";
const { definePartsStyle: i, defineMultiStyleConfig: n } = t(
  e.keys
), a = i(({ size: o }) => ({
  dialogContainer: {
    zIndex: "modal",
    height: "100vh"
  },
  dialog: {
    maxWidth: o || "xs",
    minWidth: "360px",
    padding: 6,
    boxShadow: "400",
    backgroundColor: "white",
    maxHeight: "100vh",
    _focusWithin: { boxShadow: "200 !important" }
  },
  header: {
    padding: 0,
    fontSize: "3xl",
    flex: 0,
    fontWeight: "medium"
  },
  closeButton: {
    position: "absolute",
    top: "3",
    insetEnd: "3"
  },
  body: {
    padding: 0,
    marginTop: 4,
    flexGrow: 1,
    overflowX: "hidden",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    alignContent: "start"
  },
  footer: {
    marginTop: 4,
    padding: 0,
    flex: 0
  },
  overlay: {
    bg: "transparent"
  }
})), l = n({
  baseStyle: a
});
export {
  l as Drawer
};
//# sourceMappingURL=Drawer.es.js.map
